import * as React from 'react';
import {
  List,
  Datagrid,
  TextField,
} from 'react-admin';
import Filter from './filter';
import BulkActions from './bulk-actions/';
import Pagination from '../pagination';
import { ImageField } from '../fields';

export default (props) => {
  return (
    <List
      title="Hosts"
      filters={<Filter permissions={props.permissions} />}
      sort={{ field: 'id', order: 'DESC' }}
      pagination={<Pagination />}
      perPage={100}
      bulkActionButtons={<BulkActions />}
      {...props}
    >
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="type" />
        <TextField source="name" />
        <TextField source="address" />
        <ImageField source="photo_url" label="Preview URL" width="60" />
        {(props.permissions === 'MASTER_ADMIN' || props.permissions === 'ADMIN') && (
            <TextField source="price_tier" />
        )}
        {(props.permissions === 'MASTER_ADMIN' || props.permissions === 'ADMIN') && (
            <TextField source="license_type" />
        )}
        <TextField source="updatedAt" label="Last Modified" />
      </Datagrid>
    </List>
  );
};
